import http from '../http'

export class BaseService {
  constructor() {
    this.$http = http;
  }
}
